import type { AppInfo, LoginSession } from '../types/auth';
import { createHandoffApi } from '../services/api';

// Roundvoip's id in the auth API's app list (APP_MAP.ROUNDVOIP, same in every environment)
export const ROUNDVOIP_APP_ID = import.meta.env.VITE_ROUNDVOIP_APP_ID || 'ZDLeLOvqMVX6ofY3BeZZ';

/**
 * URL opening `app` for this session. Keycloak session: one-time code (`?code=`) requested to the API;
 * legacy session (no refresh token): the access token in the URL, as before the migration.
 */
export async function getAppEntryUrl(app: AppInfo, session: LoginSession): Promise<string> {
  const lang = localStorage.getItem('language') || 'fr';
  if (session.refresh_token) {
    const { redirect_url } = await createHandoffApi(session.access_token, session.refresh_token, app.appId);
    return `${redirect_url}&lang=${encodeURIComponent(lang)}`;
  }
  return `${app.redirect_uri}?token=${session.access_token}&lang=${lang}`;
}

/** Payload of a JWT, without verifying it (display/routing only). */
export function decodeJwtPayload<T = Record<string, unknown>>(token: string): T | null {
  try {
    const binary = atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'));
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes)) as T;
  } catch {
    return null;
  }
}

export function formatDate(date: Date): string {
  return new Date(date).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
}
